import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./Components/App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { DHIThemeV516 } from "./utils/theme";
import AuthProvider from "./Components/Provider/AuthProvider";
import { ToastProvider } from "./Components/Provider/ToastProvider";
import { BrowserRouter } from "react-router-dom";
import { QueryProvider } from "./Components/Provider/QueryProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const queryClient = new QueryClient();
root.render(
  <ThemeProvider theme={DHIThemeV516}>
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <QueryProvider>
            <CssBaseline />
            <App />
          </QueryProvider>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
